import React from "react";

/**
 * component svg
 */
const CrowdScreeningIcon = function (props) {

    return (
        <svg id="undecided-answer" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 1000 1000">
            <g>
                <circle className="st0-csi" cx="253.1" cy="277" r="131.8"/>
                <path className="st0-csi" d="M474.8,671.4c21.5,0,38.2-19.2,34.8-40.7c-16.4-106.8-97.2-218.1-250.1-218.1S25.8,523.9,9.4,630.7
                    c-3.2,21.3,13.2,40.7,34.8,40.7H474.8z"/>
            </g>
            <g>
                <circle className="st0-csi" cx="734.1" cy="329" r="131.8"/>
                <path className="st0-csi" d="M955.8,723.2c21.5,0,38.2-19.2,34.8-40.7c-16.4-106.8-97.2-218.1-250.1-218.1S506.8,575.7,490.4,682.5
                    c-3.2,21.3,13.2,40.7,34.8,40.7H955.8z"/>
            </g>
            <g>
                <circle className="st0-csi" cx="449.2" cy="460.3" r="131.8"/>
                <path className="st0-csi" d="M658.2,854.8c21.5,0,38.2-19.2,34.8-40.7c-16.4-106.8-97.4-218.1-250.1-218.1S209.2,707.2,192.8,814
                    c-3.2,21.3,13.2,40.7,34.8,40.7L658.2,854.8L658.2,854.8z"/>
            </g>
        </svg>
    );
    
};

export default CrowdScreeningIcon;
